import type { Country } from '@backmarket/http-api'

export const ADDRESS_RULE_FORM_MODAL_NAME = 'ADDRESS_RULE_FORM_MODAL_FORM'
export const ADDRESS_RULE_DELETE_MODAL_NAME = 'ADDRESS_RULE_DELETE_MODAL_FORM'

export type AddressRulePayload = {
  addressId?: string
  service?: string
  markets?: Country[] | null
  categories?: string[] | null
}
